import React from 'react';
import{Link} from 'react-router-dom';
import './css/NavigationBar.css'

function NavigationBar(){


    function handleMenu(e) {
        var x = Array.from(document.querySelectorAll(".menu-item")).map(item=>{
          item.classList.remove("menuItemIsSelected")
        })
        e.target.parentElement.classList.add("menuItemIsSelected")
      }
     
    return(
        <div className="containerNav">
       
            <Link className= "menu-item menu-item-1 link" onClick={(e)=>{ handleMenu(e)}} to = "/pocetna" >
                <div>Planirana isključenja</div>
            </Link>

            <Link  className="menu-item menu-item-2 link" onClick={(e)=>{ handleMenu(e)}}  to ="/brojila" >
                <div>Mjerna mjesta</div>
            </Link>

            <Link  className="menu-item menu-item-5 link" onClick={(e)=>{ handleMenu(e)}}  to ="/download" >
                <div>Dokumenti</div>
            </Link>
            
            <Link  className="menu-item menu-item-6 link" onClick={(e)=>{ handleMenu(e)}}  to ="/contact" >
                <div>Kontakt</div>
            </Link>
            
          
            {/*<Link  style={{cursor: "not-allowed"}}  className=" link"  to ="/kalkulator">
                Kalkulator
            </Link>*/}
           
        </div>
    );

}
export default NavigationBar;